<template>
  <Breadcrumbs
    :is-direct="true"
    :prefectures="prefectures"
    :occupations="occupations"
    :industries="industries"
    :skills="skills"
    :job-features="jobFeatures"
  />
  <div v-if="isLoading">
    <div class="placeholder">
      <div
        class="flex-wrap flex-md-nowrap row container-fluid mt-0 mx-0 mb-md-0 mb-5 gap-3 justify-content-center"
      >
        <div class="w-317x col-md-4 d-md-flex d-none p-0 align-items-start">
          <div class="placeholder-text direct-search-skelton-body"></div>
        </div>
        <div class="col-md-6 p-0 mt-0 flex-grow-1 mw-634x">
          <div class="placeholder-text direct-search-skelton-body"></div>
        </div>
        <div class="col-md-2 mb-md-0 mb-5 w-250x px-0">
          <div class="placeholder-text direct-search-skelton-body"></div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    class="job-search-container row container-fluid mt-5d5 mt-md-0 mx-0 mb-md-0 mb-5 gap-3 justify-content-center"
  >
    <div class="w-317x col-md-4 d-md-flex d-none p-0 align-items-start">
      <JobSearch
        v-if="screenWidth > 768"
        :prefectures="prefectures"
        :occupations="occupations"
        :industries="industries"
        :skills="skills"
        :job-features="jobFeatures"
        :sort="sort"
        :incomes="incomes"
        :employment-types="employmentTypes"
        :input-list-job="inputListJob"
        :list-condition-search="listConditionSearch"
        :total-condition-search="totalConditionSearch"
        :initial-total-result="totalResult"
        @searchJob="onChangeResultSearch"
        @createJobCondition="onSaveJobCondition"
        @getListConditionSearch="getListConditionSearch"
      />
    </div>
    <div class="d-md-none d-block p-0">
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-primary rounded-4x d-flex justify-content-center align-items-center w-11d625 mw-186x"
          @click="onOpenModalSearchJob"
        >
          <div class="fw-medium size-12 lh-12 w-75">検索条件</div>
          <img
            src="@/assets/images/icons/zoom.svg"
            role="button"
            class="border rounded-md-circle border-third p-0d25"
          />
        </button>
      </div>

      <ModalBase
        ref="modalListConditionSearch"
        is-show-add-button
        element="modalListConditionSearchElement"
        title="保存した検索条件"
        modal-type="mx-4"
        header-background="bg-blue-primary"
        btn-colse-color="btn-close-white"
        color-text="text-white"
      >
        <template #body>
          <div class="text-center bg-grey-05 py-2">
            <img src="@/assets/images/icons/arrow-left-blue.svg" alt="Back icon" />
            <span
              class="ms-2 color-blue-primary cursor-pointer"
              data-bs-toggle="modal"
              data-bs-target="#jobCondition"
            >
              条件設定に戻る
            </span>
          </div>
          <div class="list-job-container overflow-y-scroll bg-white">
            <div v-if="totalConditionSearch == 0">
              <p class="text-center">保存した検索条件はありません</p>
            </div>
            <div v-for="item in listConditionSearch" :key="item.id" class="border-bottom px-4">
              <div class="d-flex justify-content-between">
                <div
                  class="d-flex cursor-pointer"
                  data-bs-dismiss="modal"
                  @click="onApplySearchCondition(item)"
                >
                  <img src="@/assets/images/icons/arrow_curved_left.svg" alt="Back icon" />
                  <p class="text-black my-3 mx-2 truncate-text w-16">
                    {{ item.title }}
                  </p>
                </div>
                <img
                  src="@/assets/images/icons/trash_grey.svg"
                  alt="Trash icon"
                  class="cursor-pointer"
                  @click="onOpenModaConditionSearchConfirm(item.id, item.title)"
                />
              </div>
            </div>
          </div>
        </template>
      </ModalBase>

      <div id="confirmDeleteSearchCondition" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="d-flex justify-content-end px-3 pt-3">
              <button role="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-0">
              <div class="d-flex justify-content-center p-0">
                <h6 class="m-2 px-4">｢{{ titleItemSearch }}｣ を削除しますか？</h6>
              </div>
              <div class="h-48x d-flex justify-content-center my-4">
                <button
                  type="button"
                  class="btn-center btn-primary bg-white py-2 px-4 color-blue-primary size-12 pe-auto w-8"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  キャンセル
                </button>
                <button
                  type="button"
                  class="btn-center btn-primary py-2 px-4 ms-4 text-white size-12 pe-auto w-8"
                  data-bs-dismiss="modal"
                  @click="onDeleteSearchCondition(idItemSearch)"
                >
                  削除する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="jobCondition" class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-blue-primary">
              <p class="modal-title text-start size-16 fw-bold w-100 text-white">検索条件</p>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div class="modal-body p-0 no-bounce-x">
              <JobSearchSP
                v-if="screenWidth <= 768"
                ref="jobSearchSPRef"
                :sort="sort"
                :prefectures="prefectures"
                :occupations="occupations"
                :industries="industries"
                :skills="skills"
                :job-features="jobFeatures"
                :incomes="incomes"
                :employment-types="employmentTypes"
                :total-condition-search="totalConditionSearch"
                :initial-total-result="totalResult"
                @searchJob="onChangeResultSearch"
                @createJobCondition="onSaveJobCondition"
                @getListConditionSearch="getListConditionSearch"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 p-0 mt-3 mt-md-0 flex-grow-1 mw-634x">
      <div
        class="bg-white h-3 d-flex align-items-center mt-md-0 mb-3 position-sticky z-1 job-list-tab"
      >
        <a
          href="#"
          class="col-6 text-center px-0 link-underline link-underline-opacity-0 d-inline-block size-12 fw-bold color-blue-primary menu-list-job menu-active d-inline-block"
        >
          ダイレクト求人
          <img
            src="@/assets/images/icons/question.svg"
            alt="question icon"
            class="ms-2 mb-1"
            data-bs-toggle="tooltip"
            data-bs-offset="0, 10"
            data-bs-placement="bottom"
            data-bs-custom-class="tooltip-third"
            data-bs-html="true"
            data-bs-title="「ダイレクト求人」は、掲載する企業の求人に求職者が直接応募ができる求人形式です。<br>※ダイレクトサービスご利用の方のみご応募ができます。"
          />
        </a>
        <a
          href="javascript:void(0);"
          class="col-6 text-center px-0 link-underline link-underline-opacity-0 opacity-50 d-inline-block size-12 fw-bold color-blue-primary menu-list-job d-inline-block"
          @click="redirectToAgentJobs"
        >
          エージェント求人
          <img
            src="@/assets/images/icons/question.svg"
            alt="question icon"
            class="ms-2 mb-1"
            data-bs-toggle="tooltip"
            data-bs-offset="0, 10"
            data-bs-placement="bottom"
            data-bs-custom-class="tooltip-third"
            data-bs-html="true"
            data-bs-title="「エージェント求人」は、アイムファクトリーが企業から依頼され掲載する求人に応募できる求人形式です。<br>※エージェントサービスご利用の方のみご応募ができます。"
          />
        </a>
      </div>
      <h1 class="size-16 fw-bold d-md-flex m-0 text-center">
        {{ h1Title }}
      </h1>
      <div class="d-md-flex m-0 text-center">
        <p class="size-14 fw-bold mb-0">
          この条件の求人数
          <span class="size-20 px-2">
            <vue3-autocounter
              ref="counter"
              :start-amount="0"
              :end-amount="totalResult"
              :duration="1"
              :autoinit="true"
              @finished=""
            />
          </span>
          <span>件</span>
        </p>
        <div class="d-flex justify-content-center ms-md-3 order-2">
          <div class="d-flex justify-content-between">
            <select
              v-model="sort"
              class="form-select select-input-primary w-8 h-2d5 size-14 lh-14"
              aria-label="sort-job-label"
              @change="onChangeSortDirection"
            >
              <option
                v-for="sortItem in sortCondition"
                :key="sortItem.value"
                :value="sortItem.value"
              >
                {{ sortItem.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div ref="inputListJob" class="list-job-search">
        <div v-for="job in jobs" :key="job.id" class="position-relative">
          <a
            :href="`jobs/${job.id}?direct=true`"
            class="text-decoration-none text-black"
            target="_blank"
          >
            <div
              :class="`card job-search-card w-100 mb-2 border-0 mt-3 ${
                !job.candidate_proposition?.apply ? 'pb-3d5' : 'pb-3'
              }`"
            >
              <div :id="`job-card-${job.id}`" class="card-body p-0">
                <div class="d-flex align-items-center w-100">
                  <div class="col-12 px-0 d-flex justify-content-center">
                    <div class="job-search-card-image-container">
                      <div class="image-wrapper">
                        <img
                          v-if="job.image_url"
                          :key="`job-image-${job.id}`"
                          :src="job.image_url"
                          alt="job card image"
                          class="ratio-image object-fit-contain"
                        />
                        <img
                          v-else
                          :key="`job-image-empty-${job.id}`"
                          src="@/assets/images/image-empty.png"
                          alt="job card image"
                          class="ratio-image object-fit-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="job-page__body py-3 pe-2 ps-3">
                  <div class="size-12 fw-medium pb-2">
                    {{ job.company_name }}
                  </div>
                  <div class="job-page__body-title d-flex justify-content-between">
                    <h2
                      class="m-0 size-18 lh-18 fw-bold text-md-decoration-underline flex-grow-1 text-black job-search-card-title"
                    >
                      {{ job.title }}
                    </h2>
                    <div
                      class="d-flex justify-content-md-end flex-md-row gap-2 flex-column-reverse mb-md-0 mb-auto"
                    >
                      <div
                        v-if="job.candidate_proposition?.apply"
                        class="d-flex justify-content-end justify-content-md-center"
                      >
                        <span class="tag-gray-01 size-10 lh-10 w-3d5 h-18x">応募済み</span>
                      </div>
                      <div
                        v-if="new Date(job.public_date) >= pastDate"
                        class="d-flex justify-content-end justify-content-md-center"
                      >
                        <span class="tag-pink-01 size-10 lh-10 w-2d25 h-18x">新着</span>
                      </div>
                    </div>
                  </div>
                  <div class="job-page__body-overview py-3 gap-2">
                    <div class="d-flex p-0 gap-2 flex-wrap">
                      <div
                        v-if="job.occupation_description"
                        class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                      >
                        <img src="@/assets/images/icons/ic_occupation.svg" alt="Occupation icon" />
                        <span class="size-10 ps-1 color-blue-primary">
                          {{ truncateString(job.occupation_description, 22, '...') }}
                        </span>
                      </div>
                      <div
                        v-if="job.range_income"
                        class="job-page__body-overview__place rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                      >
                        <img src="@/assets/images/icons/ic_income.svg" alt="Income icon" />
                        <span class="size-10 ps-1">
                          {{ truncateString(job.range_income, 22, '...') }}
                        </span>
                      </div>
                      <div
                        v-if="job.prefecture_name"
                        class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                      >
                        <img src="@/assets/images/icons/ic_round-place-blue.svg" alt="Place icon" />
                        <span class="size-10 ps-1 lh-10 color-blue-primary">
                          {{ truncateString(job.prefecture_name, 22, '...') }}
                        </span>
                      </div>
                      <div
                        v-if="job.industry_name"
                        class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                      >
                        <img src="@/assets/images/icons/ic_industry.svg" alt="Industry icon" />
                        <span class="size-10 ps-1 color-blue-primary">
                          {{ truncateString(job.industry_name, 22, '...') }}
                        </span>
                      </div>
                      <div
                        v-if="job.skill"
                        class="job-page__body-overview__place border border-blue-primary rounded-10x h-1d5 d-flex justify-content-center align-items-center px-2"
                      >
                        <img src="@/assets/images/icons/gear-white.svg" alt="Skill icon" />
                        <span class="size-10 ps-1 color-blue-primary">
                          {{ truncateString(job.skill, 22, '...') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="job-page__body-description d-flex flex-column">
                    <div class="fw-bold mb-2">仕事内容</div>
                    <div v-if="isDescriptionLong(job.description)">
                      <SanitizedHtml
                        :html="
                          job.isShowFullDescription
                            ? job.description
                            : truncateHtml(job.description, 200)
                        "
                        class="job-description"
                      />
                      <span
                        class="color-grey-text-des cursor-pointer"
                        @click="handleShowHideDescription(job.id)"
                      >
                        {{ job.isShowFullDescription ? '折りたたむ' : 'もっとみる' }}
                      </span>
                    </div>
                    <div v-else>
                      <SanitizedHtml :html="job.description" class="job-description" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <div
            v-if="!job.candidate_proposition?.apply"
            class="d-flex justify-content-center mb-3 position-absolute bottom-0 start-50 translate-middle-x"
          >
            <button
              v-if="job.candidate_proposition && job.candidate_proposition.job_like == 'anxious'"
              type="button"
              name="favorite"
              class="btn bg-grey-05 rounded-24 px-5 py-2 size-12"
              @click.prevent="onFavoriteJob(job)"
            >
              <img src="@/assets/images/icons/checked.svg" alt="checked icon" class="me-1" />
              気になる済み
            </button>
            <button
              v-else
              type="button"
              name="favorite"
              class="btn btn-outline-secondary rounded-24 px-5 py-2 size-12"
              @click.prevent="onFavoriteJob(job)"
            >
              <img
                src="@/assets/images/icons/star-border-blue.svg"
                alt="checked icon"
                class="me-1"
              />
              気になる
            </button>
          </div>
        </div>
      </div>
      <div v-if="pagy.page" class="pagination d-flex justify-content-center mt-3 mx size-12">
        <vue-awesome-paginate
          v-model="pagy.page"
          :on-click="navigateToPage"
          :total-items="pagy.count"
          :items-per-page="30"
          :max-pages-shown="screenWidth <= 768 ? getMaxVisiblePagesSP() : getMaxVisiblePages()"
          :show-ending-buttons="screenWidth <= 768 ? false : true"
          :show-breakpoint-buttons="false"
          :hide-prev-next-when-ends="true"
          first-page-content="最初へ"
          last-page-content="最後へ"
        >
          <template #prev-button>
            <a
              class="page-link cursor-pointer w-2 h-2 d-flex justify-content-center align-items-center border-0 rounded-4x"
              aria-label="previous"
            >
              <img src="@/assets/images/icons/paginate-angle-left.svg" alt="" />
            </a>
          </template>

          <template #next-button>
            <a
              class="page-link cursor-pointer w-2 h-2 d-flex justify-content-center align-items-center border-0 rounded-4x"
              aria-label="next"
            >
              <img src="@/assets/images/icons/paginate-angle-right.svg" alt="" />
            </a>
          </template>
        </vue-awesome-paginate>
      </div>
    </div>
    <div class="col-md-2 mb-md-0 mb-5 w-250x px-0">
      <div v-if="jobViewHistory.length" class="bg-white-primary w-100 border border-third rounded">
        <div class="company-information overflow-y-scroll">
          <div class="company-information__header border-bottom border-third py-3">
            <h2 class="text-center size-14 color-blue-primary mb-0">閲覧履歴</h2>
          </div>
          <div
            v-for="job in jobViewHistory"
            :key="job.jobId"
            class="company-information__body border-bottom size-12 px-2"
          >
            <a
              class="size-12 p-3 border-bottom link-info text-black text-decoration-none cursor-pointer"
              target="_blank"
              rel="noopener noreferrer"
              :href="`/jobs/${job.jobId}?direct=true`"
            >
              <h4 class="fw-bold size-12 text-decoration-underline">
                {{ job.title }}
              </h4>
              <div class="d-block p-0 gap-2">
                <div
                  v-if="job.occupation != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_occupation.svg" alt="Occupation icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.occupation, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.income != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_income.svg" alt="Income icon" />
                  <span class="size-10 ps-1">{{ job.income }}</span>
                </div>
                <div
                  v-if="job.place != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_round-place-blue.svg" alt="Place icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.place, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.industry != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/ic_industry.svg" alt="Industry icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.industry, 25, '...') }}</span>
                </div>
                <div
                  v-if="job.skill != ''"
                  class="job-page__body-overview__place rounded-10x h-1d5 d-flex align-items-center px-2"
                >
                  <img src="@/assets/images/icons/gear-white.svg" alt="Skill icon" />
                  <span class="size-10 ps-1">{{ truncateString(job.skill, 25, '...') }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <ModalStandard ref="welcomeModal" modal-id="welcomeModal" hide-footer="true" hide-header="true">
      <div class="d-flex justify-content-end">
        <button class="btn-close" @click="closeWelcomeModal"></button>
      </div>
      <div class="text-center p-4">
        <h5 class="mb-4">社内SE転職ナビ ダイレクトへようこそ</h5>
        <p class="mb-4">ダイレクトサービスの利用が開始されました。</p>
        <p class="mb-4">
          ダイレクト求人に応募したり、
          <br />
          企業からのスカウトを受け取りましょう！
        </p>
        <p class="mb-4">
          プロフィールを充実させるほど、
          <br />
          企業からのスカウトが届きやすくなります！
        </p>
        <button class="btn btn-primary size-12 w-184x py-3 rounded-5" @click="closeWelcomeModal">
          閉じる
        </button>
      </div>
    </ModalStandard>
  </div>
  <Direct />
  <div v-if="relatedJobs?.length > 0" class="d-flex justify-content-center mb-5 mb-md-0">
    <div class="job-related w-100">
      <h4 class="mt-4 text-center size-18 fw-bold">
        {{ prefectureName + 'の案件をお探しですか？' }}
      </h4>
      <SwiperComponent :jobs="relatedJobs" />
    </div>
  </div>
  <ScrollToTopButton />
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, nextTick, watch, computed } from 'vue';
import { Modal, Tooltip } from 'bootstrap';
import JobSearch from '@/pages/candidate/job/direct/JobSearch.vue';
import JobSearchSP from '@/pages/candidate/job/direct/JobSearchSP.vue';
import { PaginationType } from '@/types/models/PaginationType';
import {
  createJobProposition,
  getJobSearch,
  getListConditionJobSearch,
  updateJobProposition,
  deleteConditionJobSearch,
} from '@/apis/job.api';
import {
  getEmploymentTypes,
  getIncomes,
  getIndustries,
  getJobFeature,
  getOccupations,
  getPrefectures,
  getSkills,
} from '@/apis/candidate';
import { PrefecturePrimary } from '@/types/models/prefecture';
import { OccupationPrimary } from '@/types/models/occupation';
import { IndustryType } from '@/types/models/industryType';
import { SkillsType } from '@/types/models/skill';
import { SearchConditionType } from '@/types/models/searchConditionType';
import { JobFeaturePrimary } from '@/types/models/jobFeatureType';
import Vue3Autocounter from 'vue3-autocounter';
import SwiperComponent from '@/components/Swiper/RelatedJob.vue';
import { truncateString } from '@/utils/string';
import { JobType } from '@/types/models/JobType';
import { IncomePrimary } from '@/types/models/income';
import { EmploymentTypePrimary } from '@/types/models/employmentType';
import { SEARCH_PATH, AGENT_SEARCH_PATH, CANDIDATE_SIGN_UP_PATH } from '@/constant/routers/path';
import router from '@/routers';
import { useRoute } from 'vue-router';
import ModalBase from '@/components/common/ModalBase/index.vue';
import ModalStandard from '@/components/common/ModalBase/standard.vue';
import Direct from '@/components/common/PlatformModal/Direct.vue';
import { useHead } from '@vueuse/head';
import ScrollToTopButton from '@/components/ScrollToTopButton.vue';
import Breadcrumbs from '@/pages/candidate/job/Breadcrumbs.vue';
import AuthService from '@/services/auth.service';
import SanitizedHtml from '@/components/common/SanitizedHtml.vue';

const route = useRoute();
const welcomeModal = ref<InstanceType<typeof ModalBase> | null>(null);

const modalListConditionSearch = ref<InstanceType<typeof ModalBase> | null>(null);
const modalElement = ref();
const jobSearchSPRef = ref<InstanceType<typeof JobSearchSP> | null>(null);

const prefectures = ref<PrefecturePrimary[]>([]);
const occupations = ref<OccupationPrimary[]>([]);
const incomes = ref<IncomePrimary[]>([]);
const industries = ref<IndustryType[]>([]);
const skills = ref<SkillsType[]>([]);
const jobFeatures = ref<JobFeaturePrimary[]>([]);
const employmentTypes = ref<EmploymentTypePrimary[]>([]);
const isLoading = ref(true);
const screenWidth = ref<number>(window.innerWidth);
const listConditionSearch = ref();
const totalConditionSearch = ref(0);
const idItemSearch = ref(0);
const titleItemSearch = ref('');
const inputListJob = ref(null);
const platform = ref();
const userLoggedIn = ref(false);

const updateScreenWidth = (): void => {
  screenWidth.value = window.innerWidth;
};

const initPagination = {
  count: null,
  from: null,
  to: null,
  next: null,
  prev: null,
  page: null,
  pages: null,
};

interface InitialDataType {
  keywords: string | null;
  job_types: string | string[] | null;
  prefectures: string | string[] | null;
  cities: string | string[] | null;
  min_annual_income: number | null;
  max_annual_income: number | null;
  industries: string | string[] | null;
  skills: string | string[] | null;
  employment_types: string | string[] | null;
  job_features: string | string[] | null;
}

const initialData: InitialDataType = {
  keywords: null,
  job_types: null,
  prefectures: null,
  cities: null,
  min_annual_income: null,
  max_annual_income: null,
  industries: null,
  skills: null,
  employment_types: null,
  job_features: null,
};
const currentDate = new Date();
const pastDate = new Date(currentDate);
pastDate.setDate(currentDate.getDate() - 7);

const pagy = ref<PaginationType>(initPagination);
const jobs = ref();
const relatedJobs = ref();
const jobViewHistory = ref();
const prefectureName = ref<string | null>(null);
const data = ref<InitialDataType>(initialData);
const totalResult = ref();

const updateMetaTag = (): void => {
  const existingMeta = document.querySelector('meta[name="robots"]');
  if (existingMeta) {
    document.head.removeChild(existingMeta);
  }

  if (jobs.value.length === 0) {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
  }
};

onMounted(async () => {
  window.scrollTo(0, 0); //placeholderを画面内に表示させるための対応
  try {
    // データの初期化
    data.value = {
      ...initialData,
      keywords: (route.query.keywords as string) || null,
      job_types: route.query.job_types || null,
      prefectures: route.query.prefectures || null,
      cities: route.query.cities || null,
      min_annual_income: Number(route.query.min_annual_income) || null,
      max_annual_income: Number(route.query.max_annual_income) || null,
      industries: route.query.industries || null,
      skills: Array.isArray(route.query.skills)
        ? route.query.skills
        : route.query.skills
        ? [route.query.skills]
        : null,
      employment_types: route.query.employment_types || null,
      job_features: route.query.job_features || null,
    };

    await Promise.all([getJobs(), getAllData(), getListConditionSearch()]).catch((error) => {
      console.error('Error loading additional data:', error);
    });

    isLoading.value = false;

    window.scrollTo(0, 0); //求人情報反映後にスクロール位置を0にするための対応

    // その他の初期化処理
    window.addEventListener('resize', updateScreenWidth);
    nextTick(() => {
      new Tooltip(document.body, {
        selector: "[data-bs-toggle='tooltip']",
        customClass: 'tooltip-third',
      });
    });

    nextTick(() => {
      if (route.query.welcome_popup === 'true') {
        welcomeModal.value?.show();
      }
    });
    jobViewHistory.value = JSON.parse(localStorage.recentlyJob || '[]');
  } catch (error) {
    console.error('Error during component mount:', error);
    isLoading.value = false;
  }

  // ログインチェック
  AuthService.isAuthenticated().then((isAuthenticated) => {
    userLoggedIn.value = isAuthenticated;
  });
});

watch(
  () => jobs.value,
  () => {
    updateMetaTag();
  }
);

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScreenWidth);
});

const sortCondition = ref([
  { text: '新着順', value: 'public_date' },
  { text: '年収順', value: 'annual_max_income_id' },
]);
const sort = ref('public_date');

const getJobs = async (): Promise<void> => {
  try {
    const params = {
      ...data.value,
      sort_by: sort.value,
      page: Math.max(Number(route.query.page) || 1, 1),
    };

    const response = await getJobSearch(params);
    if (response.status === 200) {
      jobs.value = response.data.jobs;
      platform.value = response.data.platform;
      totalResult.value = response.data.pagy.count;
      relatedJobs.value = response.data.related_jobs;
      prefectureName.value = response.data.prefecture_name;
      pagy.value = response.data.pagy;
    }
  } catch (error) {
    console.error('Error fetching jobs:', error);
  }
};

const onFavoriteJob = async (job: JobType): Promise<void> => {
  if (!userLoggedIn.value) {
    window.location.href = CANDIDATE_SIGN_UP_PATH;
    return;
  }

  if (platform.value === 'agent') {
    showAgentModal();
    return;
  }

  job.candidate_proposition ? await updateFavoriteJob(job) : await createFavoriteJob(job);
};

const showAgentModal = (): void => {
  const modalElementDOM: HTMLElement | null = document.getElementById('platformDirectModal');
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const createFavoriteJob = async (job: JobType): Promise<void> => {
  const response = await createJobProposition({
    proposition_form: { job_id: job.id },
  });
  job.candidate_proposition = response.data.proposition;
};

const updateFavoriteJob = async (job: JobType): Promise<void> => {
  const response = await updateJobProposition(job.candidate_proposition.id);
  job.candidate_proposition = response.data.proposition;
};

const onChangeResultSearch = (resultSearch: any, dataSearch: any): Promise<void> => {
  jobs.value = resultSearch.data.jobs;
  pagy.value = resultSearch.data.pagy;
  data.value = dataSearch;
  totalResult.value = pagy.value.count;
  const paramsUrl = {
    ...route.query,
    page: undefined,
    keywords: dataSearch.keywords,
  };
  router.push({ path: SEARCH_PATH, query: paramsUrl });
};

const onChangeSortDirection = async (): Promise<void> => {
  data.value = Object.assign({}, data.value, { sort_by: sort.value, page: 1 });
  const response = await getJobSearch(data.value);
  if (response.status == 200) {
    jobs.value = response.data.jobs;
    pagy.value = response.data.pagy;
    totalResult.value = pagy.value.count;
  }
};

const navigateToPage = async (page: number): Promise<void> => {
  if (window.scrollY > 0) window.scrollTo(0, 0);
  data.value = Object.assign({}, data.value, {
    page: page,
    sort_by: sort.value,
  });
  const response = await getJobSearch(data.value);
  if (response.status == 200) {
    jobs.value = response.data.jobs;
    pagy.value = response.data.pagy;
    totalResult.value = pagy.value.count;
    const paramsUrl = { ...route.query, page: pagy.value.page };
    router.push({ path: SEARCH_PATH, query: paramsUrl });
  }
};

const onSaveJobCondition = (): void => {
  getListConditionSearch();
};

// Get data

const getAllData = async (): Promise<void> => {
  await Promise.all([
    getPrefecturesData(),
    getOccupationsData(),
    getIndustryData(),
    getSkillsData(),
    getJobFeatureData(),
    getIncomesData(),
    getEmploymentTypesData(),
  ]);
};

const getPrefecturesData = async (): Promise<void> => {
  const response = await getPrefectures();
  if (response.status === 200) {
    prefectures.value = response.data;
  }
};

const getOccupationsData = async (): Promise<void> => {
  const response = await getOccupations();
  if (response.status === 200) {
    occupations.value = response.data;
  }
};

const getIncomesData = async (): Promise<void> => {
  const response = await getIncomes();
  if (response.status === 200) {
    incomes.value = response.data;
  }
};

const getIndustryData = async (): Promise<void> => {
  const response = await getIndustries();
  if (response.status === 200) {
    industries.value = response.data;
  }
};

const getSkillsData = async (): Promise<void> => {
  const response = await getSkills();
  if (response.status === 200) {
    skills.value = response.data;
  }
};

const getJobFeatureData = async (): Promise<void> => {
  const response = await getJobFeature();
  if (response.status === 200) {
    jobFeatures.value = response.data;
  }
};

const getEmploymentTypesData = async (): Promise<void> => {
  const response = await getEmploymentTypes(true);
  if (response.status === 200) {
    employmentTypes.value = response.data;
  }
};

const onOpenModaConditionSearchConfirm = (id: number, title: string): void => {
  idItemSearch.value = id;
  titleItemSearch.value = title;
  const modalElementDOM: HTMLElement | null = document.getElementById(
    'confirmDeleteSearchCondition'
  );
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const getListConditionSearch = async (): Promise<void> => {
  const response = await getListConditionJobSearch();
  if (response.status == 200 && response?.data?.job_search_conditions) {
    listConditionSearch.value = response?.data?.job_search_conditions.filter(
      (item) => item.service_type_flag != true
    );
    totalConditionSearch.value = listConditionSearch?.value?.length;
  }
};

const onDeleteSearchCondition = async (id: number): Promise<void> => {
  const response = await deleteConditionJobSearch(id);
  if (response.status == 200) {
    const inputSaveJobAvailable = document.getElementById('save-job-available');
    const inputSaveJobUnavailable = document.getElementById('save-job-unavailable');
    await getListConditionSearch();
    if (totalConditionSearch.value < 10 && inputSaveJobAvailable && inputSaveJobUnavailable) {
      inputSaveJobAvailable.classList.toggle('d-none');
      inputSaveJobAvailable.classList.toggle('d-block');
      inputSaveJobUnavailable.classList.toggle('d-none');
      inputSaveJobUnavailable.classList.toggle('d-block');
    }
  }
};

const onApplySearchCondition = (searchCondition: SearchConditionType): void => {
  jobSearchSPRef.value?.onApplySearchCondition(searchCondition);
};

const onOpenModalSearchJob = (): void => {
  const modalElementDOM: HTMLElement | null = document.getElementById('jobCondition');
  if (!modalElementDOM) return;
  modalElement.value = new Modal(modalElementDOM);
  modalElement.value.show();
};

const stripHtmlTags = (html: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const isDescriptionLong = (jobDescription: string): boolean => {
  const plainText = stripHtmlTags(jobDescription);
  return plainText.length > 200;
};

const handleShowHideDescription = (jobId: number): void => {
  const jobIndex = jobs.value.findIndex((item) => item.id == jobId);
  jobs.value[jobIndex].isShowFullDescription = !jobs.value[jobIndex].isShowFullDescription;
  if (!jobs.value[jobIndex].isShowFullDescription) {
    const cardJobElement = document.getElementById(`job-card-${jobId}`);
    cardJobElement?.scrollIntoView(true);
  }
};

const redirectToAgentJobs = (): void => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete('direct');
  urlParams.delete('page');
  urlParams.delete('employment_types');
  urlParams.delete('job_features');

  if (urlParams.has('min_annual_income')) {
    const value = urlParams.get('min_annual_income') || '';
    urlParams.delete('min_annual_income');
    urlParams.set('wage_min', value);
  }
  if (urlParams.has('max_annual_income')) {
    const value = urlParams.get('max_annual_income') || '';
    urlParams.delete('max_annual_income');
    urlParams.set('wage_max', value);
  }

  window.location.href = `${AGENT_SEARCH_PATH}&${urlParams.toString()}`;
};

const closeWelcomeModal = (): void => {
  welcomeModal.value?.hide();
};

const truncateHtml = (html: string, maxLength: number): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  let truncatedText = '';
  let currentLength = 0;

  const traverseNodes = (node: any): void => {
    if (currentLength >= maxLength) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const remainingLength = maxLength - currentLength;

      if (text.length > remainingLength) {
        truncatedText += text.slice(0, remainingLength) + '...';
        currentLength = maxLength;
      } else {
        truncatedText += text;
        currentLength += text.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const clonedNode = node.cloneNode(false);
      for (const child of node.childNodes) {
        traverseNodes(child);
        if (currentLength >= maxLength) break;
      }
      if (currentLength < maxLength) {
        truncatedText += clonedNode.outerHTML;
      }
    }
  };

  traverseNodes(tempDiv);
  return truncatedText;
};

// getParentCategoryName関数を追加
const getParentCategoryName = (ids: string | string[], items: any[]): string => {
  if (!ids || !items) return '';

  // 配列でない場合は配列に変換
  const idArray = Array.isArray(ids) ? ids : [ids];
  const idNums = idArray.map((id) => parseInt(id, 10));

  // 単一のIDの場合の処理
  if (idArray.length === 1) {
    const idNum = idNums[0];

    // まず子カテゴリを探す
    for (const parent of items) {
      if (parent.children) {
        const child = parent.children.find((child) => child.id === idNum);
        if (child) {
          return child.name;
        }
      }
    }

    // 親カテゴリを探す
    const parent = items.find((item) => item.id === idNum);
    if (parent) {
      return parent.name;
    }
  } else {
    // 複数のIDの場合、単一の親カテゴリの全ての子カテゴリが選択されているかチェック
    for (const parent of items) {
      if (parent.children) {
        const childIds = parent.children.map((child) => child.id);

        // 選択されたIDが全て同じ親カテゴリの子カテゴリかチェック
        const allSelectedIdsAreChildren = idNums.every((id) => childIds.includes(id));

        // その親カテゴリの全ての子カテゴリが選択されているかチェック
        const allChildrenAreSelected = childIds.every((id) => idNums.includes(id));

        if (allSelectedIdsAreChildren && allChildrenAreSelected) {
          return parent.name;
        }
      }
    }

    // 上記の条件に当てはまらない場合（複数の異なる親の子カテゴリが選択されている場合など）
    return '';
  }

  return '';
};

const getMaxVisiblePages = (): number => {
  if (pagy.value.page <= 6) return Math.min(5 + pagy.value.page - 1, 9);
  if (pagy.value.page >= pagy.value.pages - 5)
    return Math.min(5 + (pagy.value.pages - pagy.value.page), 9);
  return 9;
};

const getMaxVisiblePagesSP = (): number => {
  if (pagy.value.page >= 4 && pagy.value.pages - pagy.value.page >= 2) return 3;
  return 4;
};

// computed プロパティを追加
const getOccupationName = computed(() =>
  getParentCategoryName(route.query.job_types, occupations.value)
);

const getIndustryName = computed(() =>
  getParentCategoryName(route.query.industries, industries.value)
);

const getSkillName = computed(() => getParentCategoryName(route.query.skills, skills.value));

const getPrefectureName = computed(() =>
  getParentCategoryName(route.query.prefectures, prefectures.value)
);

const getJobFeatureName = computed(() =>
  getParentCategoryName(route.query.job_features, jobFeatures.value)
);

const getDisplayName = computed(() => {
  if (route.query.job_types?.length > 0 && getOccupationName.value) return getOccupationName.value;
  if (route.query.industries?.length > 0 && getIndustryName.value) return getIndustryName.value;
  if (route.query.skills?.length > 0 && getSkillName.value) return getSkillName.value;
  if (route.query.prefectures?.length > 0 && getPrefectureName.value)
    return getPrefectureName.value;
  if (route.query.keywords) return `キーワード：${route.query.keywords}`;
  if (route.query.job_features?.length > 0 && getJobFeatureName.value)
    return getJobFeatureName.value;
  return '';
});

const h1Title = computed(() => {
  const name = getDisplayName.value;
  return name ? `${name}の社内SEダイレクト求人` : 'すべての社内SEダイレクト求人';
});

const getPageTitle = (name: string): string => {
  return name
    ? `${name} の社内SE 転職・求人｜ダイレクトスカウトで企業から直接オファー - 社内SE転職ナビ`
    : '社内SEのダイレクト転職・求人検索一覧｜ダイレクトスカウトで企業から直接オファー - 社内SE転職ナビ';
};

const getPageDescription = (name: string): string => {
  return name
    ? `${name}のダイレクトIT転職・求人情報ページ。企業の人事担当者から直接スカウトを受けられるチャンス。社内SEに特化したダイレクトサービス「社内SE転職ナビ」。 大手・優良企業など豊富な求人掲載中。`
    : '国内最大級の社内SE・情報システム、転職・求人検索ダイレクトページです。企業の人事担当者から直接スカウトを受けられるチャンス。社内SEに特化したダイレクトサービス「社内SE転職ナビ」。 大手・優良企業など豊富な求人掲載中。';
};

const title = computed(() => {
  return getPageTitle(getDisplayName.value);
});

const description = computed(() => {
  return getPageDescription(getDisplayName.value);
});

const keywords = computed(() => {
  const baseKeywords =
    '社内SE,転職,求人,IT転職,IT,エンジニア,情報システム,ダイレクト求人,直接オファー,企業スカウト,社内SE転職,スキルアップ,キャリアアップ,人事担当者';
  return getDisplayName.value ? `${getDisplayName.value},${baseKeywords}` : baseKeywords;
});

const url = computed(() => {
  return window.location.origin + route.fullPath;
});

watch([title, description], () => {});

watch(
  () => route.query,
  () => {},
  { deep: true }
);

// useHeadの設定を一度だけ行う
useHead({
  title,
  meta: [
    {
      name: 'description',
      content: description,
    },
    {
      name: 'keywords',
      content: keywords,
    },
    {
      property: 'og:site_name',
      content: '社内SE転職ナビ',
    },
    {
      property: 'og:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:url',
      content: url,
    },
    {
      property: 'twitter:image',
      content: 'https://se-navi.jp/ogp_se.png',
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
  ],
});
</script>

<style lang="scss">
@import url('@/assets/stylesheets/pages/search.scss');

.job-search-container {
  @media screen and (min-width: 768px) {
    flex-wrap: nowrap;
  }
}

.job-description {
  white-space: pre-line;
}

::v-deep .job-search {
  transition: all 0.3s ease;
  max-height: calc(100vh - 30px);
  overflow-y: auto;
}

.no-bounce-x {
  @media screen and (max-width: 767px) {
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.direct-search-skelton-body {
  min-height: 80vh;
}
</style>
